import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import { Loader, Notification } from "./components/Alerts";
import { AuthLayout, PublicLayout } from "./components/Layouts";
import { useUserStore } from "./context";
import {
  BuildApp,
  Dashboard,
  EmailVerification,
  ForgotPassword,
  Generator,
  Login,
  NotFound404,
  Profile,
  ResetPassword,
  User,
  Users,
} from "./pages";
import { JsonTryParse } from "./utils/helpers";
import storage from "./utils/storage";

function App() {
  const { currentUser, setCurrentUser, setImpersonating } = useUserStore();

  useEffect(() => {
    setCurrentUser(JsonTryParse(storage.getItem(storage.ITEMS.currentUser)));
    setImpersonating(!!storage.getItem(storage.ITEMS.storageCurrentUser));
  }, [setCurrentUser, setImpersonating]);

  return (
    <div className="w-full h-screen mx-auto bg-backgroundColor overflow-x-hidden overflow-y-auto">
      <Notification />
      <Loader />

      {currentUser ? (
        <Routes>
          <Route element={<AuthLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/users" element={<Users />} />
            <Route path="/users/:id" element={<User />} />
            <Route path="/profile/:id" element={<Profile />} />
            <Route path="/buildapp" element={<BuildApp />} />
            <Route path="/generator" element={<Generator />} />
            <Route path="*" element={<NotFound404 />} />
          </Route>
        </Routes>
      ) : (
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Login />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/resetPassword/:token" element={<ResetPassword />} />
            <Route path="/verifyEmail/:token" element={<EmailVerification />} />
            <Route path="*" element={<NotFound404 />} />
          </Route>
        </Routes>
      )}
    </div>
  );
}

export default App;
